import '../../utils/index.mjs';
import Col from './src/col.mjs';
export { colProps } from './src/col.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElCol = withInstall(Col);

export { ElCol, ElCol as default };
//# sourceMappingURL=index.mjs.map
